import { MaterialRequestStatusEnum } from '../lib/enums';
import { BaseModel, PageableResponse } from './index';
import dayjs from 'dayjs';
import { dateFormat } from '../lib/utils';

export interface Movement {
  id: string;
  uuid: string;
  product: BaseModel | undefined;
  productUom?: BaseModel | undefined;
  requestUom?: BaseModel | undefined;
  requestQty: number;
  quantity: number;
  status: string;
  proderNo?: string;
  sku?: string;
}

export interface Issuance {
  id: string;
  product: BaseModel;
  productUom?: BaseModel;
  requestQty: number;
  quantity: number;
  moveDate: string;
  moveType: string;
}

export interface Summary {
  id: string;
  product: BaseModel;
  productUom: BaseModel;
  totalRequestQty: number;
  totalIssuedQty: number;
  completionPercentage: number;
}

export interface MaterialRequestStatusForm {
  status: string;
  remarks: string;
}
export const initialData: PageableResponse<MaterialRequestRecord> = {
  start: 1,
  length: 99999,
  recordsTotal: 0,
  recordsFiltered: 1,
  data: [],
};

export const initialMaterialRequestForm = {
  id: '',
  files: undefined,
  logRevisionId: '',
  createdBy: '',
  updatedBy: '',
  timeCreated: '',
  timeUpdated: '',

  code: '',
  requiredDate: dayjs(new Date()).format(dateFormat),
  issuedDate: '',
  source: '',
  proderNo: '',
  sku: '',
  type: '',
  notes: '',
  location: undefined,
  destination: undefined,
  status: MaterialRequestStatusEnum.DRAFT,
  movements: [],
  issuance: [],
  summary: [],
};

export const MRNextStatus = (
  mrStatus?: MaterialRequestStatusEnum | undefined,
) => {
  let newStatus: any;
  switch (mrStatus) {
    case 'DRAFT':
      newStatus = 'CONFIRM';
      break;
    case 'CONFIRM':
      newStatus = 'APPROVED';
      break;
    case 'APPROVED':
      newStatus = 'AVAILABLE';
      break;
    case 'AVAILABLE':
      newStatus = 'ISSUED';
      break;
    case 'ISSUED':
      newStatus = 'DONE';
      break;
    default:
      newStatus = mrStatus;
      break;
  }
  return newStatus;
};

export interface IssueMovement {
  product: BaseModel | undefined;
  productUom: BaseModel | undefined;
  quantity: number;
}

export interface MaterialRequestRecord {
  files: any;
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  timeCreated: string;
  timeUpdated: string;

  code: string;
  requiredDate: string;
  issuedDate: string;
  source: string;
  proderNo: string;
  sku: string;
  type: string;
  notes: string;
  location: BaseModel | undefined;
  destination: BaseModel | undefined;
  status: MaterialRequestStatusEnum;
  movements: Movement[];
  issuance: Issuance[];
  summary: Summary[];
}

export interface MaterialRequestFilter {
  from: string | null;
  to: string | null;
  proder?: string | null | undefined;
  sku?: string | null | undefined;
  status?: string | null | undefined;
  datepicker?: (string | null)[];
}
